import { UserBalance } from 'structure/pv2/vault/containers/UserBalance';
import { VaultMainInfo } from 'structure/pv2/vault/containers/VaultMainInfo';
import { VaultChart } from 'structure/pv2/vault/containers/VaultChart';
import { VaultDescription } from 'structure/pv2/vault/containers/VaultDescription';
import { useParams } from 'next/navigation';
import { VaultDetails } from 'structure/pv2/vault/containers/VaultDetails';
import { Title1 } from 'components/Typography';
import {
  useVault,
  useVaultAllocation,
} from 'structure/pv2/vault/hooks/useVault';
import { parseVaultId } from 'structure/pv2/vault/utils/vault';
import { Loader } from '@dapp/multi-lib/ui/loader';

export const VaultLayout = () => {
  const params = useParams<{ id: string }>();

  const vaultId = decodeURIComponent(params?.id ?? '');
  const vaultIdentity = parseVaultId(vaultId);

  if (!vaultIdentity || !vaultIdentity.address || !vaultIdentity.chainId) {
    return <Title1>Vault not found</Title1>;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const vaultQuery = useVault({
    address: vaultIdentity.address,
    chainId: vaultIdentity.chainId,
  });

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const vaultAllocationData = useVaultAllocation({
    address: vaultIdentity.address,
    chainId: vaultIdentity.chainId,
  });

  if (vaultQuery.isLoading || vaultAllocationData.isLoading) {
    return (
      <div className='flex flex-col gap-4 p-10'>
        <Title1>Loading Vault...</Title1>
        <Loader color='white' />
      </div>
    );
  }

  if (
    !vaultQuery.data &&
    vaultQuery.isFetched &&
    vaultAllocationData.isFetched
  ) {
    return <Title1>Vault not found</Title1>;
  }

  return (
    <div>
      <div className='mt-8 flex flex-col gap-4 max-lg:mt-0'>
        <div className='flex flex-col gap-4 lg:flex-row'>
          <div className='gap flex basis-5/12 flex-col gap-4'>
            <UserBalance vaultIdentity={vaultIdentity} />
            <VaultMainInfo vaultIdentity={vaultIdentity} />
          </div>
          <div className='basis-7/12'>
            <VaultChart vaultIdentity={vaultIdentity} />
          </div>
        </div>

        <VaultDescription vault={vaultQuery.data!} />
      </div>
      <div className='mt-10'>
        <VaultDetails
          vaultIdentity={vaultIdentity}
          vaultDecimals={vaultQuery.data!.decimals}
        />
      </div>
    </div>
  );
};
